module.exports = __webpack_public_path__ + "static/media/kate-mara-lesb.f50e4ace.jpg";